module.exports = __webpack_public_path__ + "img/eth.8e5316d9.svg";